<template>
  <div></div>
</template>

<script>
import { mapActions } from 'vuex';
import router from '@/router';

export default {
  name: 'OidcCallback',
  methods: {
    ...mapActions([
      'oidcSignInCallback',
    ]),
  },
  mounted() {
    this.oidcSignInCallback()
      .then((redirectPage) => {
        router.push(redirectPage);
      })
      .catch((e) => {
        console.error(e);
        // router.push('/oidc-callback-error');
      });
  },
};
</script>
